import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeModeProvider } from './context/ThemeModeContext';
import { LanguageProvider } from './context/LanguageContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeModeProvider>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </ThemeModeProvider>
  </React.StrictMode>
);
